import { BlockList, PlacementProvider } from '@zillow/cms-blocks';
import { Box, Heading } from '@zillow/constellation-10';
import React from 'react';

import { SidebarWrapper } from '../B2CPostTemplate';
import FooterTemplate from '../FooterTemplate/FooterTemplate';

import { B2BPostTemplateProps } from './B2BPostTemplate.types';
import PostByLine from './PostByLine';
import PostCategories from './PostCategories';
import PostFeaturedImage from './PostFeaturedImage';

const B2BPostTemplate: React.FC<B2BPostTemplateProps> = ({
    post: {
        title: { raw: title },
        sidebar,
        footer,
        categories,
        primaryCategory,
        author,
        readTime,
        date,
        featuredImage,
    },
    post,
    stickySidebarTop,
}) => {
    return (
        <>
            <Box
                css={{
                    maxWidth: 'breakpoint-xl',
                    marginBlock: 'looser',
                    marginInline: 'auto',
                    paddingBlock: '0',
                    paddingInline: 'default',
                }}
            >
                <Box
                    css={{
                        lg: {
                            display: 'flex',
                        },
                    }}
                >
                    <Box
                        css={{
                            flex: '1 1 0',
                            minWidth: '0',
                            maxWidth: '100%',
                        }}
                    >
                        <PostCategories
                            categories={categories}
                            primaryCategory={primaryCategory}
                        />

                        <Heading
                            level={1}
                            fontFamily="heading-alt"
                            css={{
                                color: 'inherit',
                                textStyle: {
                                    base: 'heading-sm',
                                    lg: 'heading-md',
                                },
                                marginBottom: 'default',
                            }}
                        >
                            {title}
                        </Heading>

                        {featuredImage && (
                            <PostFeaturedImage
                                featuredImage={featuredImage}
                                defaultAlt={title}
                            />
                        )}

                        <PostByLine
                            author={author}
                            readTime={readTime}
                            date={date}
                        />

                        <Box css={{ marginBottom: 'looser' }}>
                            <PlacementProvider placement="post">
                                <BlockList blocks={post.blocks || []} />
                            </PlacementProvider>
                        </Box>
                    </Box>

                    {sidebar && (
                        <Box
                            css={{
                                marginTop: 'layout.looser',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                width: '300px',
                                lgDown: {
                                    width: '100%',
                                    marginTop: '0',
                                },
                                lg: {
                                    marginLeft: 'layout.looser',
                                    marginRight: '0',
                                    marginTop: '0',
                                },
                            }}
                        >
                            <SidebarWrapper sticky top={stickySidebarTop}>
                                <BlockList blocks={sidebar?.blocks || []} />
                            </SidebarWrapper>
                        </Box>
                    )}
                </Box>
            </Box>
            {footer && <FooterTemplate footer={footer} />}
        </>
    );
};

export default B2BPostTemplate;
